import { render, staticRenderFns } from "./LivingInformation.vue?vue&type=template&id=7487b29b&scoped=true&"
import script from "./LivingInformation.vue?vue&type=script&lang=javascript&"
export * from "./LivingInformation.vue?vue&type=script&lang=javascript&"
import style0 from "./LivingInformation.vue?vue&type=style&index=0&id=7487b29b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7487b29b",
  null
  
)

export default component.exports